import classNames from 'classnames';
import React, { useState } from 'react';

import {
  circleMatePng,
  janeBermudaMatePng,
  jrLogoColorSvg,
  petSquareMatePng,
  retangleMatePng,
} from '../assets/images';
import { Tag } from './Tag';

export interface LoginCardProps {
  children?: React.ReactNode;
  showCharacters?: boolean;
  showTag?: boolean;
}

export const LoginCard: React.FC<LoginCardProps> = ({ children, showCharacters, showTag }) => {
  const [hover, setHover] = useState<boolean>(false);

  return (
    <>
      <div
        className={classNames(
          `oejr-login-characters-transition left`,
          hover && 'hovered',
          !showCharacters && 'd-none',
        )}
      >
        <img src={retangleMatePng} alt="Character 1" id="oejr-login-character-l1" />
        <img src={petSquareMatePng} alt="Character 2" id="oejr-login-character-l2" />
      </div>
      <div
        className={classNames(
          `oejr-login-characters-transition right`,
          hover && 'hovered',
          !showCharacters && 'd-none',
        )}
      >
        <img src={circleMatePng} alt="Character 1" id="oejr-login-character-r1" />
        <img src={janeBermudaMatePng} alt="Character 2" id="oejr-login-character-r2" />
      </div>
      <div
        className="oejr-login-card-svg-adapter"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <div className="oejr-login-card">
          {showTag && (
            <>
              <Tag icon="star" shape="vertical-wider-badge" variant="pink-main" />
              <Tag icon="star" shape="vertical-wider-badge" size="sm" variant="pink-main" />
            </>
          )}
          <div className="oejr-login-card-content">
            <div className="oejr-login-card-logo-wrapper">
              <img src={jrLogoColorSvg} alt="Logo" />
            </div>
            {children}
          </div>
        </div>
      </div>
    </>
  );
};
